export default __webpack_public_path__ + "static/waxandsilverringonringstick-d905ee7398bdfa7e970616f04f633848.png";